
(function($) {
	var VideoHeroView = Backbone.View.extend(_.extend({}, App._base, {
		el: '.video-hero-section',

		// Put variables here

		$playButton: null,
		$video: null, // This is the video that gets played via Vimeo
		$close: null,
		$background: null,
		$bgVideo: null, // This is the background video
		$bgImage: null, // This is the background image

		videoSize: { w: 1920, h: 1080 },

		notPlayingClass: 'pulse',
		playingClass: 'playing',
		resizeDebounce: 0,
		videoLoopTime: 8.09,

		// Put functionality here

		InitElements: function() {
			this.$playButton = $('.play-button', this.$el);
			this.$background = $('.section-background', this.$el);
			this.$bgVideo = $('video', this.$background);
			this.$bgImage = $('img', this.$background);
		},

		OnPlayClick: function(e) {
			this.$el.addClass(this.playingClass);
			this.$playButton.removeClass(this.notPlayingClass);

			this._EmbedVideo(this.proxy(function() {
				setTimeout(this.proxy(function() {
					this._ShowVideo();
				}), 1000);
			}));
		},

		OnCloseClick: function(e) {
			this.$el.removeClass(this.playingClass);
			this._ShowBackground(this.proxy(function() {
				this._KillVideo();
			}));
		},

			_EmbedVideo: function(cb) {
				this._BuildVideo();

				this._AddVimeoVideo(cb);
				//this._AddYouTubeVideo(cb);
			},

				_AddVimeoVideo: function(cb) {
					// Now put the vimeo iframe in place #D3CAB7
					// <iframe src="https://player.vimeo.com/video/145500003?autoplay=1&color=bd0009&byline=0&portrait=0&badge=0" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
					var video_id = this.$el.data('video-id'),
						$vid = $('<iframe />')
							.prop('frameborder', '0')
							.prop('webkitallowfullscreen', '')
							.prop('mozallowfullscreen', '')
							.prop('allowfullscreen', '')
							.load(this.proxy(function() {
								if (cb) { cb(); } 
							}))
						;

					this.$video.append($vid);
					$vid.prop('src', 'https://player.vimeo.com/video/'+video_id+'?autoplay=1&color=D3CAB7&byline=0&portrait=0&badge=0');
				},

				_AddYouTubeVideo: function(cb) {
					// Now put the youtube iframe in place #D3CAB7
					// <iframe width="1280" height="720" src="https://www.youtube.com/embed/tvSK2S_3K-Q" frameborder="0" allowfullscreen></iframe>
					var video_id = this.$el.data('video-id'),
						$vid = $('<iframe />')
							.prop('frameborder', '0')
							.prop('allowfullscreen', '')
							.prop('width', '1920')
							.prop('height', '1080')
							.load(this.proxy(function() {
								if (cb) { cb(); }
							}))
						;

					this.$video.append($vid);
					$vid.prop('src', 'https://www.youtube.com/embed/'+video_id+'?autoplay=1&color=D3CAB7&modestbranding=1&showinfo=0&VQ=HD1080');
				},

				_BuildVideo: function() {
					if (!this.$video) {
						this._KillVideo();

						this.$video = $('<div />')
							.addClass('video-container')
							.hide();

						this.$close = $('<div />')
							.addClass('close-button')
							.hide();

						this.$background.parent()
							.append(this.$video)
							.append(this.$close);

						this.$close.one('click', this.proxy(this.OnCloseClick));
					}
				},

				_KillVideo: function() {
					// Check if the container already exists. If so, just kill it.
					if ($('.video-container', this.$el).length) {
						$('.video-container', this.$el).remove();
					}
					this.$video = null;

					if ($('.close-button', this.$el).length) {
						$('.close-button', this.$el).remove();
					}
					this.$close = null;
				},

			_ShowVideo: function(cb) {
				// Fade section background out
				this.$video.fadeIn(1000, 'swing', this.proxy(function() {
					this.$close.fadeIn(500, 'swing');
					if (cb) { cb(); }
				}));
			},

			_ShowBackground: function(cb) {
				this.$close.fadeOut(500, 'swing');

				// Fade section background in
				this.$video.fadeOut(1000, 'swing', this.proxy(function() {
					// Set section as not playing
					if (cb) { cb(); }
				}));
			},

		OnWindowScroll: function(e) {
			if (this.$el.hasClass(this.playingClass)) {
				this.$close.trigger('click');
			}
		},

			SetSectionHeight: function() { 
				if (!this.isTablet()) {
					var wh = $(window).height(),
						hh = $('.main-header').height();
					this.$el.height(wh - hh);
				} else {
					this.$el.height('500px');
				}

				this.SetBgVideoSize();
			},

			SetBgVideoSize: function() {
				// If we're not using the video, just return
				if (!this.$bgVideo) { return; }

				// Calculate the correct width and height
				var eW = this.$el.width(),
					eH = this.$el.height(),
					vW = this.videoSize.w,
					vH = this.videoSize.h,

					vR = vH / vW,
					eR = eH / eW,

					w = 0, h = 0, s = 0;

				if ( eR > vR ) {
					h = eH;
					s = h / vH;
					w = Math.round(vW * s , 0);
				} else {
					w = eW;
					s = w / vW;
					h = Math.round(vH * s , 0);
				}

				// Once we have that, figure out the top and left
				var t = (h > eH) ? Math.round((eH - h) / 2) : 0,
					l = (w > eW) ? Math.round((eW - w) / 2) : 0
				;

				this.$bgVideo.css({
					'top': t,
					'left': l,
					'width': w,
					'height': h
				});
			},

			ShowBgVideo: function() {
				if (this.isTablet(true)) { return; }

				this.$bgVideo.fadeIn(100, 'swing', this.proxy(function() {
					this.$bgVideo.get(0).play();
				}));
			},

			OnVideoTimeUpdate: function(e) {
				var video = e.target;
				if (video.currentTime >= video.duration - 1) {
					var left = ((video.duration - video.currentTime) * 1000);
					if (left > 10) { left -= 10; }

					//console.log(left);

					setTimeout(this.proxy(function() {
						this.$bgVideo.get(0).currentTime = this.videoLoopTime;
						this.$bgVideo.get(0).play();
					}), left);
				}
			},

		OnWayPoint: function(direction) {
			if (direction === 'up') {
				this.RestartVideo();
			}
		},

		RestartVideo: function() {
			this.$bgVideo.get(0).currentTime = 0;
			this.$bgVideo.get(0).play();
		},

		OnWindowResize: function(e) {
			clearTimeout(this.resizeDebounce);
			this.resizeDebounce = setTimeout(this.proxy(function() {
				this.CheckBackground();
				this.SetSectionHeight();
			}), 250);
		},

			CheckBackground: function() {
				var ww = $(window).width();

				if (this.lastWidth != ww) {
					if (this.isTablet(true) || this.isMobile()) {
						this.$bgVideo.hide();
						this.InitBackImage();
					} else {
						this.$bgVideo.show();
						this.$background.removeAttr('style');
					}
				}

				this.lastWidth = ww;
			},

			InitBackImage: function() {
				if (undefined === this.$bgImage.data('bgResponsiveImage')) {
					this.$bgImage.bgResponsiveImage();
				}
			},

		bindEvents: function() {
			$(window).resize(this.proxy(this.OnWindowResize));
			$(window).scroll(this.proxy(this.OnWindowScroll));
			this.$playButton.click(this.proxy(this.OnPlayClick));

			this.$bgVideo.get(0).addEventListener("timeupdate", this.proxy(this.OnVideoTimeUpdate));

			// This handles the user scrolling down, then back up. It should restart the video.
			var $vhs = $('.video-hero-section');

			this.waypoint = new Waypoint({
				element: $vhs,
				offset: -($vhs.height() * 1.3),
				handler: this.proxy(this.OnWayPoint)
			});

			$(window).resize(this.proxy(this.OnWindowResize));
			this.CheckBackground();

			App.Events.on('homeClick', this.proxy(this.RestartVideo));
		},

		ready: function() {
			this.bindEvents();
			this.SetSectionHeight();
			this.ShowBgVideo();
		},

		initialize: function(options) {
			this.InitElements();
			App.Events.on('ready', this.proxy(this.ready)); 
		}
	}));

	App.Views.VideoHero = new VideoHeroView();
})(jQuery);  